import { jsx as _jsx } from "react/jsx-runtime";
import { STANDARD_SPACING } from "../config.js";
export default function ResponsiveStack(props) {
    return (_jsx("div", { className: "d-flex flex-column justify-content-center flex-" + (props.flex ?? "sm") + "-row gap-" + STANDARD_SPACING, children: props.children }));
}
